<template>
  <div>
    <div>
      <StripeAccount
        :setup-mode="setupMode"
        class="mb-8"
      />
      <div class="xl:flex">
        <BankAccountContainer class="mb-12 xl:w-1/2 xl:mr-4" />
        <MembershipFeeContainer class="xl:ml-4" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapMutations } from 'vuex'
import BankAccountContainer from './Account/BankAccountContainer'
import StripeAccount from './Account/StripeAccount'

export default {
  name: 'PaymentsSetup',
  components: {
    StripeAccount,
    BankAccountContainer,
  },
  props: {
    stripeAccount: {
      type: Object,
      required: false,
      default: null,
    },
    setupMode: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.setStripeAccount(this.stripeAccount)
  },
  methods: {
    ...mapMutations({
      setStripeAccount: 'paymentsSetStripeAccount',
    }),
  },
}
</script>
